import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const[upd1,setupd1]=useState("None");
const[upd2,setupd2]=useState("None");
const[upd3,setupd3]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x29bd193e8dd8a9b29480b1679ae6d796b12731ea";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0xAd25207fD0FF51BaADea3Cb549470Fe04693A6a1";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
	  let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);

      var i = 0;
      document.querySelector("#us1").value  = (alltasks[13]);
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[36])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[33])/1000000000000000000;
    
     setreward2(reward2);
     const reward3 = Number(alltasks[27])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23]);
      setreward4(reward4);
      const reward5 =  Number(alltasks[24]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28])/1000000000000000000;
      setreward6(reward6);

      const reward7 =  Number(alltasks[35])/1000000000000000000;
      setreward7(reward7);


     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);
     


     const dd2 = Number(alltasks[30]?.toString?.() || alltasks[30]);
setDD2(dd2);

const dd1 = Math.floor(Date.now() / 1000);
setDD1(dd1);

// remaining seconds (24 hours)
const totalSeconds = Math.max(0, 86400 - (dd1 - dd2));

// convert to hh:mm:ss
const hours = Math.floor(totalSeconds / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;

const formattedTime =
  String(hours).padStart(2, "0") + ":" +
  String(minutes).padStart(2, "0") + ":" +
  String(seconds).padStart(2, "0");

settt2(formattedTime);
const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);
       document.querySelector("#tt2").value = tt2;
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);

       const b7 = Number(alltasks[21]) ;
       setb7(b7);
       const b8 = Number(alltasks[27]) ;
       setb8(b8);
       const b9 = Number(alltasks[28]) ;
       setb9(b9);
       const b10 = Number(alltasks[29]) ;
       setb10(b10);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[21]) ;
          
 setLevel1(level1);
 const a3 = Number(alltasks1[2])/1000000000000000000;
          
     sea3(a3);

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
     const pack1 = Number(alltasks[22])/1000000000000000000;
     setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://blockvault.top/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd1 = Number(alltasks[29])/1000000000000000000;
          
     setupd1(upd1);
	 const upd2 = Number(alltasks[30])/1000000000000000000;
          
     setupd2(upd2);
	 const upd3 = Number(alltasks[31])/1000000000000000000;
          
     setupd3(upd3);


console.log(pack);


 const b16 = Number(alltasks[16])/1000000000000000000 - Number(alltasks[15])/1000000000000000000;
 setb16(b16);

        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
     <input type="hidden" id ="us1"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <section>
      <div class="Effective-con bg-overly-img w-100">
        <div class="container overlay-content">
          <div class="Effective-sec-heading text-center">
            <h5>Dashboard</h5>
          
          </div>
        <div class="row wow fadeInUp justify-content-center text-center">
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4> JOIN</h4>
         
                   <Buy state={state}  />
      </div>
    </div>
  </div>
 
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Withdraw</h4>
        <p><input type="text" style={{backgroundColor:"white", color:"black",fontSize:"1rem",marginTop:"-2rem",width:"12rem"}} id ="test" ></input> </p>
        <Buy3 state={state}  />
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4> TRADE </h4>
        <p> <Buy1 state={state}  /> </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4> NEXT TRADE IN </h4>
        <p> {tt2}  </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Total Withdrawal </h4>
        <p>  {wlevel1} USDT </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Pending Withdrawal </h4>
        <p>  {b16}  USDT </p>
      </div>
    </div>
  </div>
   <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 > My Investment </h4>
        <p>  {pack} USDT</p>
      </div>
    </div>
  </div>
 
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4> Direct Team </h4>
        <p> {direct} </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level Team </h4>
        <p>  {level} </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4> Team Business </h4>
        <p> {level1} USDT  </p>
      </div>
    </div>
  </div>

 
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level Bonus  </h4>
        <p>  {x3} USDT</p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Trading Bonus </h4>
        <p> {x1} USDT </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4> Total Bonus </h4>
        <p>  {tt} USDT </p>
      </div>
    </div>
  </div>
   <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 >Fast Track Royalty </h4>
        <p> {reward1} USDT </p>
       
      </div>
    </div>
  </div>

     <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 >Group Royalty </h4>
        <p> {reward2} USDT </p>
       
      </div>
    </div>
  </div>
 
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>  Current Week Direct Business </h4>
        <p> {reward4} USDT </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>  Current Week Team Business </h4>
        <p> {reward5} USDT </p>
      </div>
    </div>
  </div>

   <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 >Reward </h4>
        <p> {reward6} USDT </p>
       
      </div>
    </div>
  </div>
     <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 >Salary </h4>
        <p> {reward7} USDT </p>
       
      </div>
    </div>
  </div>
 
   
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>  Level 1 Business  </h4>
        <p>{b1} USDT  </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 2 Business </h4>
        <p> {b2} USDT  </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4> Level 3 Business  </h4>
        <p> {b3} USDT </p>
      </div>
    </div>
  </div>
   <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 > Level 4 Business </h4>
        <p> {b4} USDT</p>
       
      </div>
    </div>
  </div>
 
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img2.png" class="img-fluid" />
      </figure>
      <div>
        <h4>  Level 5 Business </h4>
        <p>  {b5} USDT </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 6 Business  </h4>
        <p> {b6} USDT </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 7 Business  </h4>
        <p> {b7} USDT </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 8 Business  </h4>
        <p> {b8} USDT </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 9 Business  </h4>
        <p> {b9} USDT </p>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img3.png" class="img-fluid" />
      </figure>
      <div>
        <h4>Level 10 Business  </h4>
        <p> {b10} USDT </p>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img4.png" class="img-fluid" />
      </figure>
      <div>
        <h4> Account  </h4>
        <p style={{wordBreak:"break-all"}}>   {account} </p>
      </div>
    </div>
  </div>
   <div class="col-lg-3 col-md-6 col-12">
    <div class="Effective-sec-item mb-lg-0 mb-4 text-center">
      <figure>
        <img src="assets/image/Effective-sec-item-img1.png" class="img-fluid" />
      </figure>
      <div>
        <h4 > My Referlink  </h4>
        <p> {referlink}

 <button
  type="button"
  onClick={() => navigator.clipboard.writeText(referlink)}
  style={{
    marginLeft: "6px",
    padding: "4px",
    width: "28px",
    height: "28px",
    cursor: "pointer",
    border: "none",
    background: "transparent",
  }}
>
  <img src="copy.png" width={12} height={12} alt="Copy" />
</button> </p>
       
      </div>
    </div>
  </div>
 
  

 
 </div>
        </div>
      </div>
    </section>

 

    
</div>
  );
}

export default App;